import { inject, Injectable } from '@angular/core';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { ICmsPageResource } from '@icms/core/resource/page/icms-page.resource';
import { NBlogCategoryPageType } from '../../../cms/blog/page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../../cms/blog/page/post-view/cms-blog-post.namespace';
import { NBlogRootPageType } from '../../../cms/blog/page/root-view/cms-blog-root-page.namespace';
import { NInformationPageType } from '../../../cms/information/page/cms-information-page.component';
import { LocalPage } from './local-page';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NICmsOutletBlockComponent } from '../../outlet-block/icms-outlet-block.component';

@Injectable({
    providedIn: 'root'
})
export class LocalPageResource extends ICmsPageResource<LocalPage> {
    static override instance = LocalPage;

    private readonly iCmsBlockResource = inject(ICmsBlockResource);

    loadInformationHeaderBlock(variant: string, params: TLoadDependeciesParams | undefined) {
        return this.iCmsBlockResource.retrieve({ bareUrl: NICmsOutletBlockComponent.BLOCK_ID, variant }, params);
    }

    loadInformationContentBlock(variant: string, params: TLoadDependeciesParams | undefined) {
        return this.iCmsBlockResource.retrieve({ bareUrl: NICmsOutletBlockComponent.BLOCK_ID, variant }, params);
    }

    /**
     * Loads all blog categories
     */
    loadBlogRoot(verbosity = 2, params: TLoadDependeciesParams | undefined): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NBlogRootPageType.typeId }, verbosity }, params);
    }

    /**
     * Loads all blog categories
     */
    loadBlogCategories(verbosity = 2, params: TLoadDependeciesParams | undefined): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NBlogCategoryPageType.typeId }, verbosity }, params);
    }

    /**
     * Loads all blog posts
     */
    loadBlogPosts(verbosity = 2, params?: TLoadDependeciesParams | undefined): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NBlogPostPageType.typeId }, verbosity }, params);
    }

    /**
     * Loads all information root children
     */
    loadInformationRootChildren(verbosity = 2, rootId: number, params: TLoadDependeciesParams | undefined): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NInformationPageType.typeId, parent: rootId }, verbosity }, params);
    }
}
